<template>
	<div class="bill_template template_4" :data-no-translate="!$root.invoicePrintInSelectedLanguage || null" :style="{paddingTop: invoiceFieldsObj.pageTopMargin.value && !$root.TransactionSettings.fullPagePrint ? invoiceFieldsObj.pageTopMargin.value + 'px' : '0px', marginBottom: invoiceFieldsObj.pageBottomMargin.value && !$root.TransactionSettings.fullPagePrint ? invoiceFieldsObj.pageBottomMargin.value + 'px' : '0px'}" :class="{'noborder':!data.templateSettings.tableRowBorder, 'preview':preview, 'print-settings':isEditable, 'non-editable':!isEditable, 'gridall':getGridClass==1, 'griditems':getGridClass==2, 'font_small':invoiceFieldsObj.fontSize.value=='small' && !$root.TransactionSettings.fullPagePrint, 'font_large':invoiceFieldsObj.fontSize.value=='large' && !$root.TransactionSettings.fullPagePrint,  'font_xl':invoiceFieldsObj.fontSize.value=='xl' && !$root.TransactionSettings.fullPagePrint, 'font_xxl':invoiceFieldsObj.fontSize.value=='xxl' && !$root.TransactionSettings.fullPagePrint}" full-width-light v-if="dataLoaded">
		<table id="header_template_4" full-width>
			<tbody>

				<!-- <tr class="border-bottom">
					<td center-align class="noborder">
						<div full-height class="title invoice_title pl-2 pt-1 pb-1" :style="{'color':invoiceColor=='#4b77be' ? '#ffffff' : '#000000'}">
							<template v-if="$root.CurrentBusiness.GSTRegistrationStatus == 1 && data.transactionDetails.transactionListId == 10003">
								{{summary.totalTax && !hasNilRatedItems ? data.transactionDetails.invoiceTitle : summary.totalTax && hasNilRatedItems ? 'Invoice-cum-Bill of Supply' : 'Bill Of Supply'}}
							</template>
							<template v-else>
								{{data.transactionDetails.invoiceTitle}}
							</template>
						</div>
					</td>
				</tr> -->

				<tr>
					<!-- <td left-align :style="{'background':invoiceColor}" class="noborder"> -->
                    <td left-align class="noborder" :style="{'background':invoiceColor}">
						<div full-height class="title invoice_title pt-1 pb-1 center-align">
							<template v-if="$root.CurrentBusiness.GSTRegistrationStatus == 1 && data.transactionDetails.transactionListId == 10003">
								{{summary.totalTax && !hasNilRatedItems ? data.transactionDetails.invoiceTitle : summary.totalTax && hasNilRatedItems ? 'Invoice-cum-Bill of Supply' : 'Bill Of Supply'}}
							</template>
							<template v-else>
								{{data.transactionDetails.invoiceTitle}}
							</template>
						</div>
					</td>
				</tr>

				<tr v-if="irnNumberQR">
					<td class="noborder border-bottom business_row" :colspan="headers.length" :class="{'pt-3':isEditable}">

						<!-- <div class="col50_2 no-right-padding no-left-padding" :class="{'hasLogo':!preview && data.templateSettings.businessLogo && $root.CurrentBusiness.businessLogo && fn_showSection(logoField.showInPrintOut)}"> -->
						<div class="col50_2 no-right-padding no-left-padding">
							<div>IRN: {{ this.data.transactionDetails.additionalData.eInvoiceDetails.irnNumber }}</div>
							<div>Ack No.: {{ this.data.transactionDetails.additionalData.eInvoiceDetails.ackNumber }}</div>
							<div>Ack Date.: {{ this.data.transactionDetails.additionalData.eInvoiceDetails.ackDate | moment("DD-MMM-YYYY") }}</div>
						</div>

						<div class="col50_2 no-right-padding no-left-padding right-align">
							<div font10 class="mb-1">E-Invoice</div>
							<img width="48" :src="irnNumberQR" alt="irnnumber_qrcode">
						</div>
					</td>
				</tr>

				<tr right-align v-if="!data.transactionDetails.status">
					<!-- <td class="noborder redcolor" colspan="3">Cancelled!</td> -->
					<td class="noborder pb-0" colspan="3">
						<div class="invoice_cancel_label">Cancelled</div>
					</td>
				</tr>

				<tr v-if="subtitle.data && subtitle.data.content">
					<td class="noborder pl-2 pr-2" :colspan="headers.length">
						<div v-html="subtitle.data.content" v-ripple :class="{'editable':isEditable}" @click="fn_editPrintField(subtitle.fieldId)"></div>
					</td>
				</tr>

				<tr class="border-bottom">
					<td class="noborder business_row" :colspan="headers.length" :class="{'pt-3':isEditable}">

						<div class="col50_2 pl-1" :class="{'hasLogo':!preview && data.templateSettings.businessLogo && $root.CurrentBusiness.businessLogo && fn_showSection(invoiceFieldsObj.businessLogo.status)}" v-if="($root.CurrentBusiness.businessLogo && fn_showSection(invoiceFieldsObj.businessLogo.status)) || (header.data && header.data.content && fn_showSection(invoiceFieldsObj.header.status))">

							<div class="business_logo" v-if="data.templateSettings.businessLogo && $root.CurrentBusiness.businessLogo && fn_showSection(invoiceFieldsObj.businessLogo.status)" :class="{'editable':isEditable, 'fade-opacity':!invoiceFieldsObj.businessLogo.status}" @click="fn_editLogo">
								<img :style="{marginLeft: invoiceFieldsObj.logoLeftMargin.value ? invoiceFieldsObj.logoLeftMargin.value + 'px' : '0px'}" :class="{'large_logo':invoiceFieldsObj.logoSize.value == 'large', 'xl_logo':invoiceFieldsObj.logoSize.value == 'xl'}" :src="$root.CurrentBusiness.businessLogo"/>
								<!-- <div class="editabled-field-label" v-if="isEditable"><v-icon>edit</v-icon> Logo</div> -->
							</div>

							<div class="business_logo" :class="{'editable':isEditable}" @click="fn_editLogo" v-if="(!data.templateSettings.businessLogo || !$root.CurrentBusiness.businessLogo) && isEditable">
								<div style="text-align: center;padding: 18px 8px;font-size: 10px;">+ Logo</div>
								<!-- <div class="editabled-field-label" v-if="isEditable"><v-icon>add</v-icon> Logo</div> -->
							</div>

							<div style="clear:both;width:48px;float:left" class="pt-1" v-if="isEditable && data.templateSettings.businessLogo && $root.CurrentBusiness.businessLogo">
								<v-switch class="hide-margins small-switch mt-0 mb-0 ml-0" hide-details :height="17"  nopadding v-model="invoiceFieldsObj.businessLogo.status" @change="fn_copyFieldObj(invoiceFieldsObj.businessLogo)"></v-switch>
							</div>

							<div class="business_details" :class="{'nopadding': (!data.templateSettings.businessLogo || !$root.CurrentBusiness.businessLogo || !invoiceFieldsObj.businessLogo.status) && !isEditable, 'pl-2':!preview && (data.templateSettings.businessLogo || $root.CurrentBusiness.businessLogo)}" v-if="header.data && header.data.content && fn_showSection(invoiceFieldsObj.header.status) || isEditable">
								<!-- <div v-html="header.data.content" v-if="header.data && header.data.content" v-ripple :class="{'editable':isEditable}" @click="fn_editBusiness"></div> -->
								<div v-html="header.data.content" v-ripple :class="{'editable':isEditable, 'fade-opacity':!invoiceFieldsObj.header.status, 'pa-2':header.data && !header.data.content}" @click="fn_editPrintField(header.fieldId)"></div>
								<div class="editabled-field-label" v-if="isEditable"><v-icon>edit</v-icon> Business Details</div>
								<div class="pt-1" v-if="isEditable">
									<v-switch class="hide-margins small-switch float-right mt-0 mb-0 ml-0" hide-details :height="17"  nopadding v-model="invoiceFieldsObj.header.status" @change="fn_copyFieldObj(invoiceFieldsObj.header)"></v-switch>
								</div>
							</div>

							<!-- <div style="clear:both;width:48px" class="pt-1" v-if="isEditable && data.templateSettings.businessLogo && $root.CurrentBusiness.businessLogo && logoField.fieldId">
								<v-switch class="hide-margins small-switch float-right mt-0 mb-0 ml-0" hide-details :height="17"  nopadding v-model="logoField.showInPrintOut" @change="fn_toggleField($event, logoField.fieldId)"></v-switch>
							</div> -->
						</div>

						<div class="col50_2 nopadding">

							<!-- <div style="padding: 1px 2px;border:1px solid;margin-bottom:2px" :style="{'borderColor':invoiceColor}" v-if="data.transactionDetails.transactionListId == 10003 && (($route.query.invoiceFor && $route.query.invoiceFor!='Standard') || (invoiceFor && invoiceFor!='Standard'))"> -->
                            <!-- <div style="padding: 1px 2px;border:1px solid;margin-bottom:2px" :style="{'borderColor':invoiceColor}" v-if="data.transactionDetails.transactionListId == 10003 && (($route.query.invoiceFor && $route.query.invoiceFor!='Standard') || (invoiceFor && invoiceFor!='Standard'))"> -->
							<div class="pa-1 bottomborder" :style="{'borderColor':invoiceColor}" v-if="data.transactionDetails.transactionListId == 10003 && (($route.query.invoiceFor && $route.query.invoiceFor!='Standard') || (invoiceFor && invoiceFor!='Standard'))">
								{{$route.query.invoiceFor ? $route.query.invoiceFor : invoiceFor ? invoiceFor : ''}}
							</div>

							<v-layout row wrap>

								<v-flex xs4 sm4 md4 pa-1>
								    <div><span>{{data.transactionDetails.transactionListId == 10003 ? "Invoice" : fn_getTransactionTitle(data.transactionDetails.transactionListId)}}</span> <span data-no-translate>No</span></div>
									<div class="break_word"><strong data-no-translate>{{data.transactionDetails.transactionNumber}}</strong></div>

									<!-- <br>

									<div v-if="data.transactionDetails.partyDetails && data.transactionDetails.partyDetails.gstNumber">
										<div>GSTIN</div>
										<div><strong>{{data.transactionDetails.partyDetails.gstNumber}}</strong></div>
									</div> -->
								 </v-flex>

							  	<v-flex xs4 sm4 md4 pa-1>
								    <div>Date of <span>{{data.transactionDetails.transactionListId == 10003 ? "Invoice" : fn_getTransactionTitle(data.transactionDetails.transactionListId)}}</span></div>
									<div><strong>
										<template v-if="$root.TransactionSettings.invoiceDateFormat">
											{{ data.transactionDetails.transactionDate | moment($root.TransactionSettings.invoiceDateFormat) }}
										</template>
										<template v-else>
											{{ data.transactionDetails.transactionDate | moment("DD-MMM-YYYY") }}
										</template>
									</strong></div>
								</v-flex>

								<v-flex xs4 sm4 md4 pa-1 v-if="data.transactionDetails.refNumber">
								    <div>Bill No</div>
									<div><strong>{{ data.transactionDetails.refNumber }}</strong></div>
								</v-flex>

								<v-flex xs4 sm4 md4 pa-1 v-if="data.transactionDetails.refDate">
								    <div>Bill Date</div>
									<div><strong>{{ data.transactionDetails.refDate | moment("DD-MMM-YYYY") }}</strong></div>
								</v-flex>

                                <v-flex xs4 sm4 md4 pa-1 v-if="$root.CurrentBusiness.GSTRegistrationStatus == 1">
                                    <div>Place of Supply</div>
                                    <div><strong>{{fn_getPlaceOfSupply()}}</strong></div>
                                </v-flex>

							  	<!-- <v-flex mt-2 xs6 sm6 md6 v-if="data.transactionDetails.partyDetails && data.transactionDetails.partyDetails.gstNumber">
                                    <div>GSTIN</div>
                                    <div><strong>{{data.transactionDetails.partyDetails.gstNumber}}</strong></div>
                                </v-flex> -->

                                <!-- <v-flex xs2 sm2 md2></v-flex> -->

                                <v-flex mt-2 xs12 sm12 md12 v-if="data.transactionDetails.paymentTerm && data.transactionDetails.paymentTerm!=-1">
                                    <!-- <div>Term of Payment</div>
                                    <div><strong>{{data.transactionDetails.paymentTerm}} Days</strong></div> -->
									<template v-if="$root.TransactionSettings.showDueDate">
										<div>Due Date</div>
										<div><strong>{{ getDueDate() }}</strong></div>
									</template>
									<template v-else>
										<div>Term of Payment</div>
										<div><strong>{{data.transactionDetails.paymentTerm}} Days</strong></div>
									</template>
                                </v-flex>
							</v-layout>

						</div>	
					</td>
				</tr>

				<tr>
					<td :colspan="headers.length" class="noborder" full-height nopadding>

						<div full-height class="col33_3" :class="{'col50_2':!otherFields.length}">
							
							<template v-if="data.transactionDetails.partyDetails.partyName && fn_showSection(invoiceFieldsObj.billingLabel.status)">

								<span :class="{'fade-opacity':!invoiceFieldsObj.billingLabel.status}" font-heavy v-html="billingLabel.data.content" v-if="billingLabel.data && billingLabel.data.content"></span>

								<div v-ripple :class="{'editable':isEditable && data.transactionDetails.partyDetails.partyName, 'fade-opacity':!invoiceFieldsObj.billingLabel.status}" @click="fn_editParty">

									<div v-if="data.transactionDetails.partyDetails.partyName">
                                        <div><strong>{{billerName ? billerName : data.transactionDetails.partyDetails.partyName}}</strong></div>
                                        <div v-if="billingAddress">{{billingAddress}}</div>
                                        <div v-if="partyPhoneBilling || data.transactionDetails.partyDetails.primaryMobileNumber">Ph: {{partyPhoneBilling ? partyPhoneBilling : data.transactionDetails.partyDetails.primaryMobileNumber}}</div>
										<div v-if="data.transactionDetails.partyDetails.email">{{'Email: ' + data.transactionDetails.partyDetails.email}}</div>
                                        <div v-if="data.transactionDetails.partyDetails && data.transactionDetails.partyDetails.gstNumber">GSTIN: {{data.transactionDetails.partyDetails.gstNumber}}</div>
										<div v-if="data.transactionDetails.partyDetails && data.transactionDetails.partyDetails.msmeUdyamNumber">MSME/Udyam No: {{data.transactionDetails.partyDetails.msmeUdyamNumber}}</div>
										<div v-if="data.transactionDetails.partyDetails && data.transactionDetails.partyDetails.panNumber">PAN No: {{data.transactionDetails.partyDetails.panNumber}}</div>
										
										<div v-if="data.transactionDetails.partyDetails && data.transactionDetails.partyDetails.accountFields && data.transactionDetails.partyDetails.accountFields.length">
											<div v-for="(field, index) in data.transactionDetails.partyDetails.accountFields" :key="index" v-if="invoiceFieldsObj['party_'+field.fieldId] && invoiceFieldsObj['party_'+field.fieldId].status">
												<div v-if="field.fieldValue">
													{{field.fieldName}}: 
													<span v-if="field.fieldDataType == 'dateTime'">{{field.fieldValue | moment("DD-MMM-YYYY")}}</span>
													<span v-else>{{field.fieldValue}}</span>
												</div>
											</div>
										</div>
									</div>

									<div class="editabled-field-label" v-if="isEditable && data.transactionDetails.partyDetails.partyName"><v-icon>edit</v-icon> Party Details</div>
									
								</div>

								<div class="pt-1" v-if="isEditable">
									<v-switch class="hide-margins small-switch float-right mt-0 mb-0 ml-0" hide-details :height="17"  nopadding v-model="invoiceFieldsObj.billingLabel.status" @change="fn_copyFieldObj(invoiceFieldsObj.billingLabel)"></v-switch>
								</div>

							</template>

							<div class="pt-1" v-if="prescriberDetails">
								<div>Prescribed By: {{ prescriberDetails.name }}</div>
								<div v-if="prescriberDetails.regNumber">Reg. No.: {{ prescriberDetails.regNumber }}</div>
								<div v-if="prescriberDetails.mobileNumber">Ph: {{ prescriberDetails.mobileNumber }}</div>
							</div>

							<div class="pt-1" v-if="referrerDetails">
								<div>Referred By: {{ referrerDetails.name }}</div>
								<div v-if="referrerDetails.mobileNumber">Ph: {{ referrerDetails.mobileNumber }}</div>
							</div>

							<div v-if="data.transactionDetails.transactionListId == 20005 && !data.transactionDetails.partyDetails.partyName">
								Supplier not applicable
							</div>

						</div>

						<div full-height class="col33_3" :class="{'col50_2 noborder':!otherFields.length}">

							<template v-if="data.transactionDetails.partyDetails.partyName && fn_showSection(invoiceFieldsObj.shippingLabel.status)">

								<span :class="{'fade-opacity':!invoiceFieldsObj.shippingLabel.status}" font-heavy v-html="shippingLabel.data.content" v-if="shippingLabel.data && shippingLabel.data.content"></span>

								<div v-ripple :class="{'editable':isEditable, 'fade-opacity':!invoiceFieldsObj.shippingLabel.status}" @click="fn_editParty('expense')">

									<div v-if="data.transactionDetails.partyDetails.partyName">
                                        <div><strong>{{shipperName ? shipperName : data.transactionDetails.partyDetails.partyName}}</strong></div>
                                        <div v-if="shippingAddress">{{shippingAddress}}</div>
                                        <div v-if="partyPhoneShipping || data.transactionDetails.partyDetails.primaryMobileNumber">Ph: {{partyPhoneShipping ? partyPhoneShipping : data.transactionDetails.partyDetails.primaryMobileNumber}}</div>
										<div v-if="data.transactionDetails.partyDetails.email">{{'Email: ' + data.transactionDetails.partyDetails.email}}</div>
										<div v-if="data.transactionDetails.partyDetails && data.transactionDetails.partyDetails.panNumber">PAN No: {{data.transactionDetails.partyDetails.panNumber}}</div>
									</div>

									<div class="editabled-field-label" v-if="isEditable && data.transactionDetails.partyDetails.partyName"><v-icon>edit</v-icon> Party Details</div>
								</div>

								<div class="pt-1" v-if="isEditable">
									<v-switch class="hide-margins small-switch float-right mt-0 mb-0 ml-0" hide-details :height="17" nopadding v-model="invoiceFieldsObj.shippingLabel.status" @change="fn_copyFieldObj(invoiceFieldsObj.shippingLabel)"></v-switch>
									<!-- <div>Show in Print/Pdf</div> -->
								</div>
							</template>

						</div>


						<div full-height class="col33_3 nopadding" v-if="otherFields.length" @click="fn_openToggleOptions(invoiceFieldsObj, 'OtherField')">
							<div :class="{'editable pl-2 pr-2 pt-1 pb-1':isEditable}">
								<div class="pl-1 bottomborder" v-for="(field, fieldIndex) in otherFields" :key="fieldIndex" :class="{'fade-opacity':!field.status}" v-if="field.fieldValue && fn_showSection(field.status)">
									<template>
										<div v-if="field.fieldType == 'print' && field.additionalData.content" v-html="field.additionalData.content"></div>
										<!-- <div v-if="field.fieldType != 'print'">{{field.name}}{{field.fieldValue ? ':' : ''}}
											<span v-if="field.fieldType == 'dateTime'">{{field.fieldValue | moment("DD-MMM-YYYY")}}</span>
											<span v-else>{{field.fieldValue}}</span>
										</div>   -->
										<div v-if="field.fieldType != 'print'">{{field.fieldName}}{{field.fieldValue ? ':' : ''}}
											<span v-if="field.fieldDataType == 'dateTime'">{{field.fieldValue | moment("DD-MMM-YYYY")}}</span>
											<span v-else>{{field.fieldValue}}</span>
										</div>  
									</template>
								</div>
							</div>
						</div>

					</td>
				</tr>

				<tr v-if="data.transactionDetails.expenseCategoryName">
					<td class="noborder pl-2 pr-2 border-bottom-none" :colspan="headers.length">
						<div><strong>Expense For</strong>: {{data.transactionDetails.expenseCategoryName}}</div>
					</td>
				</tr>


			</tbody>
		</table>

		<!-- dummy table row to show dashed line on editable -->
		<template v-if="isEditable && filteredItems && filteredItems.length">
			<div style="padding: 0px 8px;background: #f0f0f0;width: max-content;font-size: 8px !important;"><v-icon class="mr-1">edit</v-icon> Edit Item Columns</div>
		</template>
		<table class="items_table" id="body_template_4" full-width>
			<colgroup v-if="!invoiceFieldsObj.autoColumnsWidth.value">
				<col class="content_width_cols" v-if="descriptionColspan && descriptionColspan > 1" v-for="(col, colIndex) in (descriptionColspan - 1)" :key="colIndex"></col>
				<template v-for="(col, colIndex) in headers">
					<col :class="{'content_width_cols':col.name != 'Description'}" :key="colIndex" v-if="showHideHeader(col.id)"></col>
				</template>
			</colgroup>
			
			<thead class="noborder items_header" @click="fn_openToggleOptions(invoiceFieldsObj, 'InvoiceTable')">

				<!-- dummy table row to show dashed line on editable -->
				<!-- <template v-if="isEditable && filteredItems && filteredItems.length">
					<div style="padding: 0px 8px;background: #f0f0f0;width: max-content;font-size: 8px !important;"><v-icon class="mr-1">edit</v-icon> Edit Item Columns</div>
					<tr>
						<td :colspan="headers.length" class="noborder" style="border-top: 1px #ddd dashed !important;padding: 0px !important;padding-bottom: 4px !important;"></td>
					</tr>
				</template> -->

				<!-- <tr class="items_header" :style="{'background':invoiceColor}"> -->
                <tr class="items_header" :style="{'background':invoiceColor}">
					<template v-for="(header, index) in headers">
						<td :colspan="header.name == 'Description' ? descriptionColspan : 1" v-if="showHideHeader(header.id)" class="noborder" :key="index" :class="{'right-align':  header.name!='#' && header.name!='Description' && header.name!='HSN/SAC' && header.name!='Batch#', 'fade-opacity':fadeHeaderOpacity(header.id)}" :style="{'minWidth':header.name=='Description' ? '30%' : 'auto'}">
							<!-- <strong>{{header.name}}</strong> -->
							<template v-if="invoiceFieldsObj[header.id] && header.id != 'tableColGST' && header.id != 'tableColDiscount'">
								<strong>{{invoiceFieldsObj[header.id].sectionName}}</strong>
							</template>
							<template v-else>
								<strong>{{header.name}}</strong>
							</template>
						</td>
					</template>
				</tr>

			</thead>
			
			<tbody @click="fn_openToggleOptions(invoiceFieldsObj, 'InvoiceTable')">



				<template v-for="(item, groupIndex) in filteredItems" class="noborder border-bottom border-left border-right">
					<tr :id="item.baseTransactionNumber" v-if="isRef && !invoiceFieldsObj.hideBaseTransactionNumber.status" class="noborder border-bottom"><td :colspan="headers.length"><strong>{{item.baseTransactionNumber}}</strong></td></tr>
					<!-- <tr v-for="(row, index) in item.items" :key="item.baseTransactionNumber + index" class="noborder border-bottom transaction_items" :style="{'background': index % 2 != 0 && data.templateSettings.alternateRowColor ? data.templateSettings.tableRowColor : '#ffffff' }"> -->
					<tr v-for="(row, index) in item.items" :id="'item_'+(index+1)" :key="item.baseTransactionNumber + index" class="noborder border-bottom transaction_items items_row" :class="{'add_bottom_border':invoiceFieldsObj.itemRowBorder.value && index != item.items.length - 1}">
						<!-- <td>{{index+1}}</td> -->
						<td>
							{{
								invoiceFieldsObj.hideBaseTransactionNumber.status
								? fn_getGlobalIndex(groupIndex, index)
								: index + 1
							}}
						</td>
						<!-- <td v-for="col in row">{{col}}</td> -->
						<td style="width: 30%;" :colspan="descriptionColspan" class="item_details">
							<!-- {{row.itemName}} -->
							<!-- <template v-if="fn_getEnabledItemsDetailsArray() && fn_getEnabledItemsDetailsArray().length">
								<template v-for="(itemDetail, index) in fn_getEnabledItemsDetailsArray()" v-if="row[fn_getItemDetailKey(itemDetail.fieldId)] && fn_showSection(itemDetail.status)">
									<br v-if="!invoiceFieldsObj.itemDetailsAlignment.status && index != 0">
									<span class="description_row" :class="{'fade-opacity':!itemDetail.status}"><em>{{ row[fn_getItemDetailKey(itemDetail.fieldId)] }}</em></span>
									<span v-if="invoiceFieldsObj.itemDetailsAlignment.status && index != fn_getEnabledItemsDetailsArray().length - 1"> / </span>
								</template>
							</template> -->
							<template v-if="fn_getEnabledItemsDetailsArray() && fn_getEnabledItemsDetailsArray().length">
								<template v-for="(itemDetail, itemDetailsIndex) in fn_getEnabledItemsDetailsArray()" v-if="row[fn_getItemDetailKey(itemDetail.fieldId)] && fn_showSection(itemDetail.status)">
									<br v-if="!invoiceFieldsObj.itemDetailsAlignment.status && itemDetailsIndex != 0">
									<span class="description_row" :class="{'fade-opacity':!itemDetail.status}">
										<template v-if="itemDetail.fieldId == 'tableColItemName'">
											<span :class="{'font-heavy':invoiceFieldsObj.tableColItemName.isBold}">{{ row[fn_getItemDetailKey(itemDetail.fieldId)] }}</span>
										</template>
										<template v-else>
											<em><span v-html="row[fn_getItemDetailKey(itemDetail.fieldId)]"></span></em>
										</template>
									</span>
										<span v-if="invoiceFieldsObj.itemDetailsAlignment.status"> / </span>
								</template>
							</template>

							<template v-else>
								{{row.itemName}}
							</template>

							<!-- displaying custom item fields under item name -->
							<template v-if="otherFieldsPosValue == 2">
								<br>
								<span class="description_row" v-for="(field, fieldIndex) in row.customFields" :key="fieldIndex + field.fieldId" :class="{'fade-opacity':!invoiceFieldsObj[field.fieldId].status}" v-if="fn_showSection(invoiceFieldsObj[field.fieldId].status)">
									<br v-if="fieldIndex != 0">
									<span v-if="field.fieldType == 'dateTime'">
										<em>{{field.fieldValue | moment("DD-MMM-YYYY")}}</em>
									</span>
									<span v-else>
										<em>{{field.value}}</em>
									</span>
								</span>
							</template>
							<!-- <template v-if="row.productCode && fn_showSection(invoiceFieldsObj.tableColProductCode.status)">
								<br>
								<span class="description_row" :class="{'fade-opacity':!invoiceFieldsObj.tableColProductCode.status}"><em>{{ row.productCode }}</em></span>
							</template>
							<template v-if="row.itemDescription && fn_showSection(invoiceFieldsObj.tableColItemDescription.status)">
								<br>
								<span class="description_row" :class="{'fade-opacity':!invoiceFieldsObj.tableColItemDescription.status}"><em>{{ row.itemDescription }}</em></span>
							</template>
							<template v-if="row.description && fn_showSection(invoiceFieldsObj.tableColItemNote.status)">
								<br>
								<span class="description_row" :class="{'fade-opacity':!invoiceFieldsObj.tableColItemNote.status}"><em>{{ row.description }}</em></span>
							</template>
							<template v-if="row.brand && fn_showSection(invoiceFieldsObj.tableColBrand.status)">
								<br>
								<span class="description_row" :class="{'fade-opacity':!invoiceFieldsObj.tableColBrand.status}"><em>{{ row.brand }}</em></span>
							</template>
							<template v-if="row.company && fn_showSection(invoiceFieldsObj.tableColCompany.status)">
								<span class="description_row" :class="{'fade-opacity':!invoiceFieldsObj.tableColCompany.status}">/<em>{{ row.company }}</em></span>
							</template>
							<template v-if="row.category && fn_showSection(invoiceFieldsObj.tableColCategory.status)">
								<span class="description_row" :class="{'fade-opacity':!invoiceFieldsObj.tableColCategory.status}">/<em>{{ row.category }}</em></span>
							</template> -->

							<br v-if="row.field1 || row.field2 || row.field3 || row.field4">
							<template v-if="row.field1 && row.field1.length">
								<span>Serial Number: </span>
								<span class="description_row" v-for="(field, index) in row.field1" :key="index">{{ field }} <span v-if="row.field1.length - 1 != index">, </span></span>
								<br>
							</template>

							<template v-if="row.field2 && row.field2.length">
								<span>IMEI Number: </span>
								<span class="description_row" v-for="(field, index) in row.field2" :key="index">{{ field }} <span v-if="row.field2.length - 1 != index">, </span></span>
								<br>
							</template>

							<template v-if="row.field3 && row.field3.length">
								<span>Part Number: </span>
								<span class="description_row" v-for="(field, index) in row.field3" :key="index">{{ field }} <span v-if="row.field3.length - 1 != index">, </span></span>
								<br>
							</template>

							<template v-if="row.field4 && row.field4.length">
								<span>Model Number: </span>
								<span class="description_row" v-for="(field, index) in row.field4" :key="index">{{ field }} <span v-if="row.field4.length - 1 != index">, </span></span>
							</template>
						</td>

						<td right-align v-for="(header, headerIndex) in headers" :key="headerIndex" v-if="header.fieldId && fn_showSection(invoiceFieldsObj[header.id].status) && otherFieldsPosValue == 1" :class="{'fade-opacity':!invoiceFieldsObj[header.id].status}">
							<span v-for="(field, fieldIndex) in row.customFields" :key="fieldIndex" v-if="header.fieldId == field.fieldId">
								<template v-if="field.fieldType == 'dateTime'">
									{{field.value | moment("DD-MMM-YYYY")}}
								</template>
								<template v-else>
									{{field.value}}
								</template>
							</span>
						</td>

						<td v-if="isHsn">{{row.hsn ? row.hsn : '-'}}</td>
						<!-- <td right-align>{{row.qty}}</td>
						<td right-align>{{row.unit}}</td>
						<td right-align v-if="isMrp">{{row.mrp ? $root.fixed2Decimal(row.mrp) : ''}}</td>
						<td right-align>{{row.rate ? $root.fixed2Decimal(row.rate) : ''}}</td> -->
						<td right-align :class="{'fade-opacity':!invoiceFieldsObj.tableColQty.status}" v-if="fn_showSection(invoiceFieldsObj.tableColQty.status)">{{row.qty}}</td>

						<td v-if="row.batchNumber != undefined" class="break_word">{{row.batchNumber}}</td>
						<td right-align v-if="row.batchSize != undefined">{{row.batchSize}}</td>
						<td style="min-width: 65px;" right-align v-if="row.mfgDate != undefined">{{row.mfgDate}}</td>
						<td style="min-width: 65px;" right-align v-if="row.expDate != undefined">{{row.expDate}}</td>
						<td right-align v-if="row.purchaseRate != undefined">{{row.purchaseRate}}</td>
						
						<td right-align :class="{'fade-opacity':!invoiceFieldsObj.tableColUnit.status}" v-if="fn_showSection(invoiceFieldsObj.tableColUnit.status)">{{row.unit}}</td>
						<td right-align :class="{'fade-opacity':invoiceFieldsObj.tableColMrp && !invoiceFieldsObj.tableColMrp.status}" v-if="invoiceFieldsObj.tableColMrp && fn_showSection(invoiceFieldsObj.tableColMrp.status) && isMrp">{{row.mrp ? $root.fixed2Decimal(row.mrp) : ''}}</td>
						<td right-align :class="{'fade-opacity':!invoiceFieldsObj.tableColRate.status}" v-if="fn_showSection(invoiceFieldsObj.tableColRate.status)">{{row.rate ? row.rate : ''}}</td>
						
						<td right-align :class="{'fade-opacity':!invoiceFieldsObj.tableColPrimaryQty.status}" v-if="invoiceFieldsObj.tableColPrimaryQty && fn_showSection(invoiceFieldsObj.tableColPrimaryQty.status)">{{row.primaryQty}}</td>
						<td right-align :class="{'fade-opacity':!invoiceFieldsObj.tableColSecondaryQty.status}" v-if="invoiceFieldsObj.tableColSecondaryQty && fn_showSection(invoiceFieldsObj.tableColSecondaryQty.status)">{{row.secondaryQty}}</td>
						
						<td right-align :class="{'fade-opacity':!invoiceFieldsObj.tableColPacking.status}" v-if="isPacking && fn_showSection(invoiceFieldsObj.tableColPacking.status)">{{row.packing}}</td>
						<!-- <td right-align v-for="(header, headerIndex) in headers" :key="headerIndex" v-if="header.addOnsId" v-for="(addOn, addOnIndex) in row.addOns" :key="addOnIndex">
							{{addOn.value}} {{addOn.percentage ? '@' + addOn.percentage + '%' : ''}}
						</td> -->

						<td right-align v-for="(header, headerIndex) in headers" :key="headerIndex" v-if="header.addOnsId && fn_showSection(invoiceFieldsObj.tableColDiscount.status)" :class="{'fade-opacity':!invoiceFieldsObj.tableColDiscount.status}">
							<span v-for="(addOn, addOnIndex) in row.addOns" :key="addOnIndex" v-if="header.addOnsId == addOn.addOnsId">
								<template v-if="$root.TransactionSettings.enableSingleLineAddOns">
									<span v-if="addOn.percentage && (invoiceFieldsObj.tableColDiscount.optionFlag == 1 || isEditable)" :class="{'fade-opacity': invoiceFieldsObj.tableColDiscount.optionFlag != 1}">@</span><span v-if="addOn.percentage && (invoiceFieldsObj.tableColDiscount.optionFlag != 3 || isEditable)" :class="{'fade-opacity': invoiceFieldsObj.tableColDiscount.optionFlag == 3}">{{addOn.percentage + '%'}}</span>&nbsp;<span v-if="isEditable || invoiceFieldsObj.tableColDiscount.optionFlag != 2" :class="{'fade-opacity': invoiceFieldsObj.tableColDiscount.optionFlag == 2}">{{addOn.value ? $root.fixed2Decimal(addOn.value) : ''}}</span>
								</template>

								<template v-else>
									<span v-if="isEditable || invoiceFieldsObj.tableColDiscount.optionFlag != 2" :class="{'fade-opacity': invoiceFieldsObj.tableColDiscount.optionFlag == 2}">{{addOn.value ? $root.fixed2Decimal(addOn.value) : ''}}</span>
									<br v-if="addOn.percentage && (addOn.value && invoiceFieldsObj.tableColDiscount.optionFlag == 1 || isEditable)">
									<span v-if="addOn.percentage && (invoiceFieldsObj.tableColDiscount.optionFlag == 1 || isEditable)" :class="{'fade-opacity': invoiceFieldsObj.tableColDiscount.optionFlag != 1}">@</span>
									<span v-if="addOn.percentage && (invoiceFieldsObj.tableColDiscount.optionFlag != 3 || isEditable)" :class="{'fade-opacity': invoiceFieldsObj.tableColDiscount.optionFlag == 3}">{{addOn.percentage + '%'}}</span>
								</template>
							</span>
							<!-- <span v-else>-</span> -->
						</td>

						<td right-align :class="{'fade-opacity':!invoiceFieldsObj.tableColTaxableRate.status}" v-if="fn_showSection(invoiceFieldsObj.tableColTaxableRate.status)">{{row.taxableRate ? row.taxableRate : ''}}</td>

						<!-- <td right-align v-for="(addOn, addOnIndex) in row.gstAddOns" :key="addOnIndex">
							{{addOn.value}} {{addOn.percentage ? '@' + addOn.percentage + '%' : ''}}
						</td> -->
						<!-- <td right-align v-if="summary.totalTax">{{row.taxableValue ? $root.fixed2Decimal(row.taxableValue) : ''}}</td> -->
						<td right-align v-if="hasTaxableColumn && gstAddOnsTotal && gstAddOnsTotal.length && (fn_showSection(invoiceFieldsObj.tableColTaxableValue.status) || invoiceFieldsObj.tableColTaxableValue2.status)" :class="{'fade-opacity':!invoiceFieldsObj.tableColTaxableValue.status && !invoiceFieldsObj.tableColTaxableValue2.status}">{{row.taxableValue ? $root.fixed2Decimal(row.taxableValue) : ''}}</td>
						
						<td right-align v-for="(header, headerIndex) in headers" :key="headerIndex" v-if="header.gstAddOnsId && fn_showSection(invoiceFieldsObj.tableColGST.status)" :class="{'fade-opacity':!invoiceFieldsObj.tableColGST.status}">
							<span v-for="(addOn, addOnIndex) in row.gstAddOns" :key="addOnIndex" v-if="header.gstAddOnsId == addOn.addOnsId">
								<!-- <span v-if="$root.TransactionSettings.enableSingleLineAddOns"><template v-if="getGstColumnType == 1 || getGstColumnType == 3">@</template>{{addOn.percentage + '%'}}&nbsp;</span><span v-if="isEditable || (getGstColumnType == 2 || getGstColumnType == 4)" :class="{'fade-opacity': getGstColumnType != 2 && getGstColumnType != 4}">{{addOn.value != null || addOn.value != undefined ? $root.fixed2Decimal(addOn.value) : ''}}</span>
								<span v-if="!$root.TransactionSettings.enableSingleLineAddOns"><template v-if="getGstColumnType == 2 || getGstColumnType == 4">@</template>{{addOn.percentage + '%'}}</span> -->
								<template v-if="!addOn.cessValueOnQuantity">
									<span v-if="$root.TransactionSettings.enableSingleLineAddOns && addOn.percentage != null"><template v-if="getGstColumnType == 2 || getGstColumnType == 4">@</template>{{addOn.percentage + '%'}}&nbsp;</span><span v-if="isEditable || (getGstColumnType == 2 || getGstColumnType == 4)" :class="{'fade-opacity': getGstColumnType != 2 && getGstColumnType != 4}">{{addOn.value != null || addOn.value != undefined ? $root.fixed2Decimal(addOn.value) : ''}}</span>
									<span v-if="!$root.TransactionSettings.enableSingleLineAddOns && addOn.percentage != null"><br><template v-if="getGstColumnType == 2 || getGstColumnType == 4">@</template>{{addOn.percentage + '%'}}</span>
								</template>
								<template v-else>
									{{$root.fixed2Decimal(addOn.value)}}
								</template>
							</span>
						</td>
						<!-- <td right-align>{{$root.fixed2Decimal(row.taxableValue)}}</td> -->
						<td right-align :class="{'fade-opacity':!invoiceFieldsObj.tableColTotal.status}" v-if="fn_showSection(invoiceFieldsObj.tableColTotal.status)">{{row.rate ? $root.numberToLocale(roundUpto2Decimals(row.total)) : 'Free'}}</td>
					</tr>
				</template>
					
				<!-- <tr class="items_footer noborder border-bottom" v-if="filteredItems && filteredItems.length" :style="{'background':invoiceColor}"> -->
                <tr class="items_footer noborder border-bottom" :style="{'background':invoiceColor}" v-if="filteredItems && filteredItems.length">
					<!-- <td :colspan="isHsn ? 3 : 2"><strong>Total (&#8377;)</strong></td> -->
					 <td :colspan="isHsn && !fn_customFieldColSize() ? 3 : 2"><strong>Total (&#8377;)</strong></td>

					<td v-if="descriptionColspan && descriptionColspan > 1" :colspan="descriptionColspan - 1"></td>
					
					<!-- <td :colspan="fn_customFieldColSize()" v-if="fn_customFieldColSize() && otherFieldsPosValue == 1"></td> -->
					<template v-if="invoiceFieldsObj.itemCustomFieldTotal.status">
						<td right-align v-for="(header, headerIndex) in headers" :key="headerIndex" v-if="header.fieldId && fn_showSection(invoiceFieldsObj[header.id].status) && otherFieldsPosValue == 1" :class="{'fade-opacity':!invoiceFieldsObj[header.id].status}">
							<strong>{{ fn_getFieldTotalValue(header.fieldId) }}</strong>
						</td>
					</template>
					<template v-else>
						<td :colspan="fn_customFieldColSize()" v-if="fn_customFieldColSize() && otherFieldsPosValue == 1"></td>
					</template>

					<td v-if="isHsn && fn_customFieldColSize()"></td>

					<td right-align :class="{'fade-opacity':!invoiceFieldsObj.tableColQty.status}" v-if="fn_showSection(invoiceFieldsObj.tableColQty.status)">
						<strong>{{qtyTotal ? qtyTotal : ''}}</strong>
					</td>

					<!-- <td :colspan="headers.length - addOnsTotal.length - gstAddOnsTotal.length - (isMrp ? 5 : 6) - (isHsn ? 1 : 0)"></td> -->
					<td :colspan="fn_footerColspanSize()" v-if="fn_footerColspanSize() > 0"></td>

					<td right-align :class="{'fade-opacity':!invoiceFieldsObj.tableColPrimaryQty.status}" v-if="invoiceFieldsObj.tableColPrimaryQty && fn_showSection(invoiceFieldsObj.tableColPrimaryQty.status)">
						<strong>{{primaryQtyTotal ? primaryQtyTotal : ''}}</strong>
					</td>

					<td right-align :class="{'fade-opacity':!invoiceFieldsObj.tableColSecondaryQty.status}" v-if="invoiceFieldsObj.tableColSecondaryQty && fn_showSection(invoiceFieldsObj.tableColSecondaryQty.status)">
						<strong>{{secondaryQtyTotal ? secondaryQtyTotal : ''}}</strong>
					</td>
					
					<td right-align v-for="(header, headerIndex) in headers" :key="headerIndex" v-if="header.addOnsId && fn_showSection(invoiceFieldsObj.tableColDiscount.status)" :class="{'fade-opacity':!invoiceFieldsObj.tableColDiscount.status}">
						<span v-for="(item, index) in addOnsTotal" :key="index" v-if="header.addOnsId == item.addOnsId && invoiceFieldsObj.tableColDiscount.optionFlag != 2">
							<strong v-if="item.value">{{$root.numberToLocale(item.value)}}</strong>
						</span>
					</td>

					<td right-align v-if="fn_showSection(invoiceFieldsObj.tableColTaxableRate.status)"></td>
					<!-- <td right-align v-for="(item, index) in gstAddOnsTotal" :key="index"><strong>{{item.value}}</strong></td> -->
					<!-- <td right-align v-if="summary.totalTax"><strong>{{$root.numberToLocale(data.transactionDetails.taxableValue)}}</strong></td> -->
					<td right-align v-if="data.transactionDetails.taxableValue && gstAddOnsTotal && gstAddOnsTotal.length && (fn_showSection(invoiceFieldsObj.tableColTaxableValue.status) || invoiceFieldsObj.tableColTaxableValue2.status)" :class="{'fade-opacity':!invoiceFieldsObj.tableColTaxableValue.status && !invoiceFieldsObj.tableColTaxableValue2.status}"><strong>{{$root.numberToLocale(data.transactionDetails.taxableValue)}}</strong></td>

					<td right-align v-for="(header, headerIndex) in headers" :key="headerIndex" v-if="header.gstAddOnsId && fn_showSection(invoiceFieldsObj.tableColGST.status)" :class="{'fade-opacity':!invoiceFieldsObj.tableColGST.status}">
						<span v-for="(item, index) in gstAddOnsTotal" :key="index" v-if="header.gstAddOnsId == item.gstAddOnsId && (getGstColumnType == 2 || getGstColumnType == 4)">
							<strong>{{$root.numberToLocale(item.value)}}</strong>
						</span>
					</td>

					<td right-align :class="{'fade-opacity':!invoiceFieldsObj.tableColTotal.status}" v-if="invoiceFieldsObj.tableColTotal && fn_showSection(invoiceFieldsObj.tableColTotal.status)"><strong>{{$root.numberToLocale(netTotal)}}</strong></td>
				</tr>

				<!-- dummy table row to show dashed line on editable -->
				<tr v-if="isEditable && filteredItems && filteredItems.length">
					<td :colspan="headers.length" class="noborder" style="border-bottom: 1px #ddd dashed !important;padding: 0px !important;padding-top: 4px !important;"></td>
				</tr>

			</tbody>

			<tbody id="bottom_section_body">

				<!-- Body in case of direct amount invoice (no items) -->
				<template v-if="filteredItems && !filteredItems.length">
					<tr class="noborder border-bottom items_row">
						<td>1</td>
						<td style="width: 80%;"><span class="description_row">{{data.transactionDetails.description}}</span></td>
						<td class="right-align">{{$root.numberToLocale(data.transactionDetails.taxableValue)}}</td>
					</tr>

					<!-- Footer in case of direct amount invoice (no items) -->
					<!-- <tr class="items_footer noborder border-bottom" v-else :style="{'background':invoiceColor}"> -->
					<tr class="items_footer noborder border-bottom" :style="{'background':invoiceColor}">
						<td colspan="2"><strong>Total</strong></td>
						<td class="right-align"><strong>{{$root.numberToLocale(data.transactionDetails.taxableValue)}}</strong></td>
					</tr>
				</template>

				<tr class="border-bottom" :class="{'border-top':!filteredItems.length}" v-if="isEditable || invoiceFieldsObj.amountInWords.status || invoiceFieldsObj.taxAndTotal.status">
					<td :colspan="headers.length" class="single-column-double-section noborder">
						<div full-height class="left-column">

							<div class="mb-2" v-if="unitSummary.length">
								<strong>Total Qty: </strong>
								<span v-for="(unit, uIndex) in unitSummary" :key="uIndex">
									{{ unit.qty }} {{ unit.unitName }}<span v-if="uIndex != unitSummary.length - 1">,</span>
								</span>
							</div>

							<div v-if="fn_showSection(invoiceFieldsObj.amountInWords.status)" :class="{'editable':isEditable, 'fade-opacity':!invoiceFieldsObj.amountInWords.status}">
								<div>
									<strong>Total amount (in words)</strong><br>
									{{convertNumberToWords(data.transactionDetails.roundedAmount)}} Only.
								</div>
							</div>

							<div v-if="isEditable">
                                <v-switch class="hide-margins small-switch float-right mr-1 mt-1" hide-details :height="17" nopadding v-model="invoiceFieldsObj.amountInWords.status" @change="fn_copyFieldObj(invoiceFieldsObj.amountInWords)"></v-switch>
                            </div>

							<div v-if="data.transactionDetails.notes" class="pt-1 topborder">
								<strong>Note</strong><br>
								<span v-html="data.transactionDetails.notes"></span>
								<!-- {{data.transactionDetails.notes}} -->
							</div>

							<!-- <div class="mt-2" v-if="unitSummary.length">
								<strong>Units Total</strong>
								<div v-for="(unit, uIndex) in unitSummary" :key="uIndex">
									{{ unit.unitName }}: {{ unit.qty }}
								</div>
							</div> -->
						</div>

						<div full-height class="right-column no-right-padding" right-align>
							<div v-if="fn_showSection(invoiceFieldsObj.taxAndTotal.status)" :class="{'editable':isEditable, 'fade-opacity':!invoiceFieldsObj.taxAndTotal.status}">
								<div class="table_div">
									<template v-if="showTaxLabels() && ((itemGstPercentage !== null && itemGstPercentage !== '') || summary.totalTax)">
										<div class="table_div_row">
											<div class="table_div_col">Taxable Amount (&#8377;):</div>
											<div class="table_div_col pr-1" right-align>
												<!-- <strong>{{$root.fixed2Decimal(data.transactionDetails.taxableValue)}}</strong> -->
												<strong>{{$root.numberToLocale(data.transactionDetails.taxableValue)}}</strong>
											</div>
										</div>
										<div class="table_div_row">
											<div class="table_div_col"><span>Tax</span>
												<template v-if="itemGstPercentage && gstAddOnsTotal && gstAddOnsTotal.length">@{{ itemGstPercentage }}%</template> 
												{{data.transactionDetails.isRcmApplicable ? '(RCM)' : ''}} (&#8377;):
											</div>
											<div class="table_div_col pr-1" right-align>
												<!-- <strong>{{$root.fixed2Decimal(summary.totalTax)}}</strong> -->
												<strong>{{$root.numberToLocale(summary.totalTax)}}</strong>
											</div>
										</div>
									</template>

									<div class="table_div_row" v-if="data.transactionDetails.transactionTds && data.transactionDetails.transactionTds.length">
										<div class="table_div_col">
											{{data.transactionDetails.transactionTds[0].tdsAccountName}} (&#8377;):
										</div>
										<div class="table_div_col pr-1" right-align>
											<!-- <strong>(-) {{data.transactionDetails.transactionTds[0].amount}}</strong> -->
											<strong>-{{$root.numberToLocale(data.transactionDetails.transactionTds[0].amount)}}</strong>
										</div>
									</div>

									<div class="table_div_row" v-for="(addOn, addOnIndex) in data.transactionDetails.transactionAddOns" :key="addOnIndex">
										<div class="table_div_col">{{addOn.name}} <span v-if="addOn.percentage">@{{ addOn.percentage }}%</span> {{addOn.isGst == 1 && data.transactionDetails.isRcmApplicable ? '(RCM)' : ''}} (&#8377;):</div>
										<div class="table_div_col pr-1" right-align>
											<!-- <strong>{{$root.fixed2Decimal(addOn.value)}}</strong> -->
											{{addOn.nature == 1 ? '-' : ''}}<strong>{{$root.numberToLocale(addOn.value)}}</strong>
										</div>
									</div>
									<div class="table_div_row" v-if="roundOffAmount">
										<div class="table_div_col">Round Off (&#8377;):</div>
										<div class="table_div_col pr-1" right-align>
											<!-- <strong>{{$root.fixed2Decimal(roundOffAmount)}}</strong> -->
											<strong>{{$root.numberToLocale(roundOffAmount)}}</strong>
										</div>
									</div>
									<div class="table_div_row">
										<div class="table_div_col"><strong>Total Amount (&#8377;):</strong></div>
										<div class="table_div_col pr-1" right-align>
											<!-- <strong>{{$root.fixed2Decimal(data.transactionDetails.roundedAmount)}}</strong> -->
											<strong>{{$root.numberToLocale(data.transactionDetails.roundedAmount)}}</strong>
										</div>
									</div>

									<template v-if="data.transactionDetails.paymentAccounts && data.transactionDetails.paymentAccounts.length">
										<!-- <div class="table_div_row">
											<div class="table_div_col">Payment Modes:</div>
										</div> -->

										<!-- if single payment mode -->

										<!-- <div class="table_div_row" v-if="data.transactionDetails.paymentAccounts.length==1">
											<div class="table_div_col"></div>
											<div class="table_div_col" right-align>
												(Paid by {{data.transactionDetails.paymentAccounts[0].accountLedgerName == 'Cash A/c' ? 'Cash' : data.transactionDetails.paymentAccounts[0].accountLedgerName}})
											</div>
										</div> -->

										<!-- if multiple payment modes -->
										<div class="table_div_row" v-for="(item, index) in data.transactionDetails.paymentAccounts" :key="index" v-if="!invoiceFieldsObj.hidePaymentInfo.status">
											<div class="table_div_col">Paid - {{item.accountLedgerName == 'Cash A/c' ? 'Cash' : item.accountLedgerName}} (&#8377;):</div>
											<div class="table_div_col pr-1" right-align>
												<strong>{{$root.numberToLocale(item.amount)}}</strong>
											</div>
										</div>

										<!-- <div class="table_div_row" v-if="data.transactionDetails.onCredit">
											<div class="table_div_col">Balance Amount (&#8377;):</div>
											<div class="table_div_col" right-align>
												<strong>{{$root.numberToLocale(data.transactionDetails.onCredit)}}</strong>
											</div>
										</div> -->
									</template>

									<!-- <template v-else>
										<div class="table_div_row" v-if="showBalanceLabel() && !$root.TransactionSettings.disableReceiveAmountLabel">
											<div class="table_div_col">Received (&#8377;):</div>
											<div class="table_div_col pr-1" right-align>
												<strong>0</strong>
											</div>
										</div>
									</template> -->

									<div class="table_div_row" v-if="showBalanceLabel() && fn_showSection(invoiceFieldsObj.tableColSummaryBalance.status)" :class="{'fade-opacity':!invoiceFieldsObj.tableColSummaryBalance.status}">
										<div class="table_div_col"><strong>{{invoiceFieldsObj['tableColSummaryBalance'].sectionName}}</strong> (&#8377;):</div>
										<div class="table_div_col pr-1" right-align>
											<strong>{{data.transactionDetails.onCredit ? $root.numberToLocale(data.transactionDetails.onCredit) : '0'}}</strong>
										</div>
									</div>

									<template v-if="$root.TransactionSettings.showPartyBalance && (data.transactionDetails.transactionListId == '10003' || data.transactionDetails.transactionListId == '10004' || data.transactionDetails.transactionListId == '20003' || data.transactionDetails.transactionListId == '20004' || data.transactionDetails.transactionListId == '20005')">
										<div class="table_div_row" v-if="data.transactionDetails.lastInvoice">
											<div class="table_div_col">Previous Balance (&#8377;):</div>
											<div class="table_div_col pr-1" right-align>
												{{$root.numberToLocale(fn_previousBalance())}}
											</div>
										</div>

										<div class="table_div_row">
											<div class="table_div_col">Current Balance (&#8377;):</div>
											<div class="table_div_col pr-1" right-align>
												<strong>{{$root.numberToLocale(data.transactionDetails.partyDetails.currentBalance)}}</strong>
											</div>
										</div>
									</template>

								</div>
							</div>

							<div v-if="isEditable">
                                <v-switch class="hide-margins small-switch float-right mr-1 mt-1" hide-details :height="17" nopadding v-model="invoiceFieldsObj.taxAndTotal.status" @change="fn_copyFieldObj(invoiceFieldsObj.taxAndTotal)"></v-switch>
                            </div>
						</div>

					</td>
				</tr>

				<template v-if="hsnSummary.items.length && fn_showSection(invoiceFieldsObj.hsnSummary.status)" :class="{'editable':isEditable}">
					<tr :style="{'background':invoiceColor}" class="border-bottom noborder hsn-summary-headers hsn_row" :class="{'fade-opacity':!invoiceFieldsObj.hsnSummary.status}">
						<td font-heavy center-align :colspan="fn_hsnSummaryColspan()">HSN/SAC</td>
						<td font-heavy right-align :colspan="index == 0 || index == hsnSummary.headers.length - 1 ? 2 : 1" class="hsn-dynamic-headers" v-for="(hsnHeader, index) in hsnSummary.headers">{{ hsnHeader.name }}</td>
					</tr>

					<tr class="border-bottom noborder hsn_row" v-for="(summary, summaryIndex) in hsnSummary.items" :class="{'fade-opacity':!invoiceFieldsObj.hsnSummary.status}">
						<td :colspan="fn_hsnSummaryColspan()">{{summary.hsn}}</td>
						<td right-align :colspan="2">{{$root.fixed2Decimal(summary.taxableValue)}}</td>
						<td right-align v-for="gst in summary.gstAddOns" :key="gst.addOnsId">
							{{gst.value != null ? $root.fixed2Decimal(gst.value) : ''}} <br>
							<template v-if="!gst.cessValueOnQuantity">
								<span v-if="gst.percentage !=undefined">{{ '@' + gst.percentage + '%' }}</span>
							</template>
							<template v-else>
								<template>{{ gst.cessValueOnQuantity }}/{{ summary.unit }}</template>
							</template>
						</td>
						<td v-if="fn_hsnSummaryCessQtyEmptyCol(summaryIndex)"></td>
						<td right-align :colspan="2">{{$root.numberToLocale(summary.totalTax)}}</td>
					</tr>

					<tr :style="{'background':invoiceColor}" class="border-bottom noborder hsn_row" :class="{'fade-opacity':!invoiceFieldsObj.hsnSummary.status}">
						<td font-heavy :colspan="fn_hsnSummaryColspan()">Total</td>
						<td right-align font-heavy :colspan="index == 0 || index == hsnSummary.footers.length - 1 ? 2 : 1" v-for="(footerValue, index) in hsnSummary.footers">{{$root.numberToLocale(footerValue)}}</td>
					</tr>

					<tr v-if="isEditable">
						<td style="border-color: #fff !important;" :colspan="headers.length">
							<v-switch class="hide-margins small-switch float-right mr-1 mt-1" hide-details :height="17" nopadding v-model="invoiceFieldsObj.hsnSummary.status" @change="fn_copyFieldObj(invoiceFieldsObj.hsnSummary)"></v-switch>
						</td>
					</tr>

				</template>

				<tr v-if="hasFooterSection">
                    <td :colspan="headers.length" class="noborder" :class="{'pt-4':isEditable}">
						<footer-component v-if="dataLoaded"></footer-component>
                        <!-- <div class="bottom-row-container">
                            <div full-height class="bottom-left-column">

								<template v-if="fn_showSection(invoiceFieldsObj.terms.status) && terms.fieldId">
									<div :class="{'terms-section':invoiceFieldsObj.printNote.value && invoiceFieldsObj.printNote.status}">
										<div v-ripple class="pt-1 pb-1" :class="{'fade-opacity':!invoiceFieldsObj.terms.status, 'editable':isEditable}" @click="fn_editPrintField(terms.fieldId)">
											<div v-html="terms.data.content" v-if="terms.data && terms.data.content"></div>

											<div class="editabled-field-label" v-if="isEditable"><v-icon>edit</v-icon> Terms</div>
										</div>  

										<div v-if="isEditable && terms.data && terms.data.content">
											<v-switch class="hide-margins small-switch float-right mr-1 mt-1" hide-details :height="17" nopadding v-model="invoiceFieldsObj.terms.status" @change="fn_copyFieldObj(invoiceFieldsObj.terms)"></v-switch>
										</div>
									</div>

                                </template>

									<template v-if="(isEditable && fn_showSection(invoiceFieldsObj.printNote.status) && printNote.fieldId) || (!isEditable && fn_showSection(invoiceFieldsObj.printNote.status) && invoiceFieldsObj.printNote.value)">

                                    <div class="printnote-section" :class="{'borderwhite':(!$root.CurrentBusiness.UpiID || !invoiceFieldsObj.upiDetails.status) && (!bankDetails.data || !bankDetails.data.content || !invoiceFieldsObj.bankDetails.status)}">
											<div v-ripple class="pt-2 pb-2" :class="{'fade-opacity':!invoiceFieldsObj.printNote.status && invoiceFieldsObj.printNote.value, 'editable':isEditable}" @click="fn_addNote">
											<template v-if="invoiceFieldsObj.printNote.value">
												<div><strong>Note:</strong></div>
												<div v-html="invoiceFieldsObj.printNote.value"></div>
											</template>
                                            <div class="editabled-field-label" v-if="isEditable"><v-icon>edit</v-icon> Print Note</div>
                                        </div>  

                                        <div v-if="isEditable && printNote.data && printNote.data.content">
											<v-switch class="hide-margins small-switch float-right mr-1 mt-1" hide-details :height="17"  nopadding v-model="invoiceFieldsObj.printNote.status" @change="fn_copyFieldObj(invoiceFieldsObj.printNote)"></v-switch>
                                        </div>
                                    </div>

                                </template>

								<template v-if="(showBankDetails() && $root.CurrentBusiness.UpiID && fn_showSection(invoiceFieldsObj.upiDetails.status)) || (showBankDetails() && isEditable)">
								
                                    <div class="upi-details-section" :class="{'mt-1':isEditable}">
                                        
										<div class="pb-1" :class="{'fade-opacity':!invoiceFieldsObj.upiDetails.status, 'editable':isEditable}" nopadding @click="fn_editUpiDetails">

                                            <template v-if="$root.CurrentBusiness.UpiID">

                                                <div class="qr-code-container">
                                                    <img :src="paymentQrCodeUrl">
                                                </div>

                                                <div class="qr-code-details">
                                                    <p>Scan Payment QR code using any UPI app</p>
                                                    <p>UPI ID: {{$root.CurrentBusiness.UpiID}}</p>
                                                    <p>UPI Name: {{$root.CurrentBusiness.UPIName}}</p>
                                                </div>

                                            </template>

                                            <template v-if="isEditable">
                                                <div class="editabled-field-label" v-if="$root.CurrentBusiness.UpiID"><v-icon>edit</v-icon> UPI Details</div>
                                                <div class="editabled-field-label" v-else><v-icon>add</v-icon> UPI Details</div>	
                                            </template>

                                        </div>

                                        <div class="left-align" v-if="isEditable && $root.CurrentBusiness.UpiID">
											<v-switch class="hide-margins small-switch float-right mr-1 mt-1" hide-details :height="17"  nopadding v-model="invoiceFieldsObj.upiDetails.status" @change="fn_copyFieldObj(invoiceFieldsObj.upiDetails)"></v-switch>
                                        </div>
                                    </div>

                                </template>

								<template v-if="(showBankDetails() && bankDetails.data && bankDetails.data.content && fn_showSection(invoiceFieldsObj.bankDetails.status)) || (showBankDetails() && isEditable)">

                                    <div class="bank-details-section" :class="{'mt-1':isEditable}">
										<div class="pb-1" v-ripple :class="{'fade-opacity':!invoiceFieldsObj.bankDetails.status, 'editable':isEditable}" @click="fn_editPrintField(bankDetails.fieldId)">

                                            <template v-if="isEditable">
                                                <div v-if="bankDetails.data && bankDetails.data.content" class="editabled-field-label"><v-icon>edit</v-icon> Bank Details</div>
                                                <div v-else class="editabled-field-label"><v-icon>add</v-icon> Bank Details</div>   
                                            </template>
                                            
                                            
                                            <template v-if="bankDetails.data && bankDetails.data.content">
                                                <div v-html="bankDetails.data.content"></div>
                                            </template>

                                        </div>

                                        <div v-if="isEditable && bankDetails.data && bankDetails.data.content">
											<v-switch class="hide-margins small-switch float-right mr-1 mt-1" hide-details :height="17"  nopadding v-model="invoiceFieldsObj.bankDetails.status" @change="fn_copyFieldObj(invoiceFieldsObj.bankDetails)"></v-switch>
                                        </div>
                                    </div>
                                    

                                </template>
                                

                            </div>


                            <div nopadding class="bottom-right-column">

								<template v-if="fn_showSection(invoiceFieldsObj.signatory.status)">

									<div class="pt-1 pb-1" :class="{'fade-opacity':!invoiceFieldsObj.signatory.status, 'editable':isEditable}" @click="fn_editPrintField(signatory.fieldId, 'signature')">

                                        <div right-align class="signatory" v-ripple v-html="signatory.data.content" v-if="signatory.data && signatory.data.content"></div>

                                        <div class="editabled-field-label" v-if="isEditable"><v-icon>add</v-icon> Signature</div>

                                    </div>

                                    <div class="pb-3" v-if="isEditable && signatory.data && signatory.data.content">
										<v-switch class="hide-margins small-switch float-right mr-1 mt-1" hide-details :height="17"  nopadding v-model="invoiceFieldsObj.signatory.status" @change="fn_copyFieldObj(invoiceFieldsObj.signatory)"></v-switch>
                                    </div>  

                                </template>

								<template v-if="fn_showSection(brandLogo.showInPrintOut)">
									<div :class="{'row-app-logo':isEditable}">
										<div class="invoice-footer mt-2" :class="{'fade-opacity': !brandLogo.showInPrintOut}">
											<div class="branding grey-back" style="position:relative">
												<v-btn @click="fn_toggleBrandLogo(false, 1)" v-if="!isEditable" style="border-radius: 4px;height: 18px;padding: 0px 8px 0px 6px;background: #fff;position: absolute;top: -19px;right: 0px;border: 1px #ddd solid;min-width: auto !important;" color="primary" capitalize flat class="ma-0 mt-1 remove-logo-btn"><v-icon style="font-size: 10px !important;" class="mr-1" color="primary">close</v-icon> Remove</v-btn>
												<a href="https://bizopsapp.com/" target="_blank">
													<div class="branding-box">
														<div class="dark-opacity-color powered">Powered By</div>
														<div class="title primary-color">
															<img class="brand_logo" src="../../../assets/BizOpsApp_Icon_24x24.png" alt="bizops_logo">BizOps App
														</div>
													</div>
												</a>

											</div>
										</div>
										

										<div class="pb-2 pt-2" v-if="isEditable">
											<v-switch class="hide-margins small-switch float-right mr-2 mt-0 mb-0 ml-0" hide-details :height="17" v-model="brandLogo.showInPrintOut"  nopadding @change="fn_toggleBrandLogo"></v-switch>
										</div>
									</div>
								</template>

                                
                            </div>
                        </div> -->


                    </td>
                </tr>

				<!-- <tr v-if="$root.TransactionSettings.enableCustomerSignature && data.transactionDetails.transactionListId == 10003">
					<td :colspan="headers.length">
						<div style="width: 200px;padding: 4px 0px;float: right;text-align: right;">
							<strong>Customer's Signature</strong><br>
							<div style="height: 80px;border: 1px solid #999;"></div>
						</div>
					</td>
				</tr> -->

				<tr v-if="fn_showSection(invoiceFieldsObj.bottomNote.status)">
					<td center-align class="noborder borderwhite" :colspan="headers.length">
						<div class="pa-1"v-ripple style="height:auto;" :class="{'fade-opacity':!invoiceFieldsObj.bottomNote.status && invoiceFieldsObj.bottomNote.value, 'editable mt-3':isEditable}" @click="fn_addNote('bottom_note')">
							<div v-html="invoiceFieldsObj.bottomNote.value" v-if="invoiceFieldsObj.bottomNote.value"></div>
							<div v-else>This is a Computer Generated Invoice.</div>
							<div class="editabled-field-label" v-if="isEditable"><v-icon>edit</v-icon> Edit</div>
						</div>  

						<div v-if="isEditable" style="height:auto;">
							<v-switch class="hide-margins small-switch float-right mr-1 mt-1" hide-details :height="17"  nopadding v-model="invoiceFieldsObj.bottomNote.status" @change="fn_copyFieldObj(invoiceFieldsObj.bottomNote)"></v-switch>
						</div>
					</td>
				</tr>
				<!-- <tr class="noborder" :class="{'row-app-logo':isEditable}" v-if="fn_showSection(brandLogo.showInPrintOut)">
                    <td right-align class="noborder border-top-none" :colspan="headers.length">
                        <div class="invoice-footer" :class="{'fade-opacity': !brandLogo.showInPrintOut}">
                            <div class="branding grey-back" style="position:relative">
								<v-btn @click="fn_toggleBrandLogo(false, 1)" v-if="!isEditable" style="border-radius: 4px;height: 18px;padding: 0px 8px 0px 6px;background: #fff;position: absolute;top: -19px;right: 0px;border: 1px #ddd solid;min-width: auto !important;" color="primary" capitalize flat class="ma-0 mt-1 remove-logo-btn"><v-icon style="font-size: 10px !important;" class="mr-1" color="primary">close</v-icon> Remove</v-btn>
								<a href="https://bizopsapp.com/" target="_blank">
									<div class="branding-box">
										<div class="dark-opacity-color powered">Powered By</div>
										<div class="title primary-color">
											<img class="brand_logo" src="../../../assets/BizOpsApp_Icon_24x24.png" alt="bizops_logo">BizOps App
										</div>
									</div>
								</a>

                            </div>
                        </div>
						

						<div class="pb-2 pt-2" v-if="isEditable">
                            <v-switch class="hide-margins small-switch float-right mr-2 mt-0 mb-0 ml-0" hide-details :height="17" v-model="brandLogo.showInPrintOut"  nopadding @change="fn_toggleBrandLogo"></v-switch>
                        </div>
                    </td>
                </tr> -->

			</tbody>

			<!-- <tfoot>
                <tr class="noborder">
                    <td right-align class="noborder" :colspan="headers.length">
                        <div class="invoice-footer">
                            <div class="branding grey-back">
                                <div class="branding-box">
                                    <div class="dark-opacity-color powered">Powered By</div>
                                    <div class="title primary-color">
                                        <img class="brand_logo" src="../../../assets/BizOpsApp_Icon_24x24.png" alt="bizops_logo">BizOps App
                                    </div>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </tfoot> -->

		</table>

		<!-- <div class="page-footer mt-4" id="page_footer_template_4">
			<div class="branding watermark">
				<div style="font-size:8px !important">Powered By</div>
				<div style="font-size:10px !important" class="title primary-color">
					<img src="../../../assets/Final_BizOpsLogo.svg" class="brand_logo logo_small" alt="bizops_logo">
					BizOps App
				</div>
			</div>
		</div> -->
	</div>
</template>

<script>
import {invoiceTemplateMixin} from '../invoice_template_mixin'
import footerComponent from '../components/invoice_footer_section'

	export default{
		mixins: [invoiceTemplateMixin],
		components:{
			'footer-component':footerComponent
		}
		// props:['data'],
		// data(){
		// 	return{
		// 		billingAddress:null,
		// 		partyPhoneBilling:null,
		// 		partyPhoneShipping:null,
		// 		shippingAddress:null,
		// 		otherFields:[],
		// 		// showOtherFields:false,
		// 		headers:[],
		// 		items:[],
		// 		summary:{"totalTax":0},
		// 		addOnsTotal:[],
		// 		gstAddOnsTotal:[],
		// 		netTotal:0,
		// 		isHsn:false,
		// 		isMrp:false,
		// 		header:null,
		// 		terms:null,
		// 		bankDetails:null,
		// 		signatory:null,
		// 		subtitle:null,
		// 		billingLabel:null,
		// 		shippingLabel:null,
		// 		printDetails:null,
		// 		isRef:false
		// 	}
		// },
		// methods:{
		// 	fn_init: function(){
		// 		this.fn_processAddress();
		// 		this.fn_processFields();
		// 		this.fn_processTransactionItems();
		// 		this.fn_processSummary();
		// 		this.fn_processSections();
		// 		this.fn_processKeywords();
		// 		this.fn_processPrintDetails();
		// 	},
		// 	fn_processAddress: function(){
		// 		let addresses = this.data.transactionDetails.partyDetails.address;
		// 		for(let i=0; i<addresses.length; i++){
		// 			if(addresses[i].groupTypeId==101 && !this.billingAddress){
		// 				let addressLine = addresses[i].addressLine ? addresses[i].addressLine + ', ' : '';
		// 				let city = addresses[i].city ? addresses[i].city + ', ' : '';
		// 				let state = addresses[i].state ? addresses[i].state + ', ' : '';
		// 				let country = addresses[i].country ? addresses[i].country : '';
		// 				let pincode = addresses[i].pincode ? ', ' + addresses[i].pincode : '';
		// 				this.billingAddress = addressLine + city + state + country + pincode;
		// 				this.partyPhoneBilling = addresses[i].phone ? addresses[i].phone : null;
		// 			}
		// 			else if(addresses[i].groupTypeId==102 && !this.shippingAddress){
		// 				let addressLine = addresses[i].addressLine ? addresses[i].addressLine + ', ' : '';
		// 				let city = addresses[i].city ? addresses[i].city + ', ' : '';
		// 				let state = addresses[i].state ? addresses[i].state + ', ' : '';
		// 				let country = addresses[i].country ? addresses[i].country : '';
		// 				let pincode = addresses[i].pincode ? ', ' + addresses[i].pincode : '';
		// 				this.shippingAddress = addressLine + city + state + country + pincode;
		// 				this.partyPhoneShipping = addresses[i].phone ? addresses[i].phone : null;
		// 			}
		// 			else if(addresses[i].groupTypeId==103 && !this.billingAddress && !this.shippingAddress){
		// 				let addressLine = addresses[i].addressLine ? addresses[i].addressLine + ', ' : '';
		// 				let city = addresses[i].city ? addresses[i].city + ', ' : '';
		// 				let state = addresses[i].state ? addresses[i].state + ', ' : '';
		// 				let country = addresses[i].country ? addresses[i].country : '';
		// 				let pincode = addresses[i].pincode ? ', ' + addresses[i].pincode : '';
		// 				this.billingAddress = addressLine + city + state + country + pincode;
		// 				this.shippingAddress = addressLine + city + state + country + pincode;
		// 				this.partyPhoneBilling = addresses[i].phone ? addresses[i].phone : null;
		// 				this.partyPhoneShipping = addresses[i].phone ? addresses[i].phone : null;
		// 			}
		// 		}
		// 	},
		// 	fn_processFields: function(){
		// 		this.otherFields = [];
				
		// 		// inserting ewayBillFields if applicable
		// 		if(this.data.transactionDetails.roundedAmount>=50000){
		// 			let ewayBillFields = JSON.parse(JSON.stringify(require('../../../config.js').configs.transactionFields.ewayBillDetailFields))
		// 			for(let k=0; k<ewayBillFields.length; k++){
		// 				this.data.templateSettings.printTemplateFields.push(ewayBillFields[k]);
		// 			}
		// 		}

		// 		// matching applicable fields
		// 		for(let i=0; i<this.data.templateSettings.printTemplateFields.length; i++){

		// 			let printField = this.data.templateSettings.printTemplateFields[i];
		// 			printField.fieldValue = null;

		// 			if(printField.fieldType=='print'){
		// 				printField.additionalData = JSON.parse(printField.additionalData);
		// 			}

		// 			for(let j=0; j<this.data.transactionDetails.otherDetails.transactionFields.length; j++){

		// 				let transactionField = this.data.transactionDetails.otherDetails.transactionFields[j];
		// 				if(printField.fieldId == transactionField.fieldId){
		// 					printField.fieldValue = transactionField.fieldValue;
		// 					this.otherFields.push(printField);
		// 					break;
		// 				}	
		// 			}
		// 		}

		// 		console.log(JSON.stringify(this.otherFields));
		// 	},

		// 	// fn_processFields: function(){
		// 	// 	this.otherFields = [];
		// 	// 	for(let i=0; i<this.data.transactionDetails.otherDetails.transactionSections.length; i++){
		// 	// 		let sectionObj = {};
		// 	// 		sectionObj.sectionId = this.data.transactionDetails.otherDetails.transactionSections[i].sectionId;
		// 	// 		sectionObj.sectionName = this.data.transactionDetails.otherDetails.transactionSections[i].sectionName;
		// 	// 		sectionObj.fields = [];
		// 	// 		for(let k=0; k<this.data.transactionDetails.otherDetails.transactionFields.length; k++){

		// 	// 			for(let j=0; j<this.data.templateSettings.printTemplateFields.length; j++){

		// 	// 				let field = this.data.transactionDetails.otherDetails.transactionFields[k];
		// 	// 				if(sectionObj.sectionId == field.sectionId && this.data.templateSettings.printTemplateFields[j].printTemplateFieldId == field.fieldId){
		// 	// 					let fieldObj = {};
		// 	// 					fieldObj.fieldName = field.fieldName;
		// 	// 					fieldObj.fieldValue = field.fieldValue;
		// 	// 					sectionObj.fields.push(fieldObj);
		// 	// 					break;
		// 	// 				}

		// 	// 			}
						
		// 	// 		}
					

		// 	// 		this.otherFields.push(sectionObj);
		// 	// 	}

		// 	// 	console.log(JSON.stringify(this.otherFields));
		// 	// },
		// 	fn_processTransactionItems: function(){
		// 		this.headers = [{"name":"S.No"}, {"name":"Description"}, {"name":"HSN/SAC"}, {"name":"Qty"}, {"name":"MRP"}, {"name":"Rate"}]
		// 		this.items = [];
		// 		this.isHsn = false;
		// 		this.isMrp = false;
		// 		for(let i=0; i<this.data.transactionDetails.transactionItems.length; i++){
		// 			let item = this.data.transactionDetails.transactionItems[i].cols;
		// 			let itemObj = {};
		// 			itemObj.itemName = item.itemName;
		// 			itemObj.hsn = item.hsn;
		// 			itemObj.qty = item.qty;
		// 			itemObj.mrp = item.mrp;
		// 			itemObj.rate = item.rate;
		// 			itemObj.addOns = [];
		// 			itemObj.gstAddOns = [];
		// 			itemObj.description = this.data.transactionDetails.transactionItems[i].description;
		// 			itemObj.baseTransactionNumber = this.data.transactionDetails.transactionItems[i].baseTransactionNumber;

		// 			for(let j=0; j<item.addOns.length; j++){

		// 				if(!item.addOns[j].isGst){
		// 					itemObj.addOns.push(item.addOns[j]);

		// 					let headerIndex = this.headers.findIndex(header=>{
		// 						return header.addOnsId == item.addOns[j].addOnsId;
		// 					})

		// 					if(headerIndex==-1){
		// 						let obj = {};
		// 						obj.addOnsId = item.addOns[j].addOnsId;
		// 						obj.name = item.addOns[j].name;
		// 						this.headers.push(obj);
		// 					}
		// 				}
		// 				else{
		// 					itemObj.gstAddOns.push(item.addOns[j]);
		// 				}
						
		// 			}

		// 			itemObj.taxableValue = item.taxableValue;
		// 			itemObj.total = item.netAmount;
					
		// 			this.items.push(itemObj);

		// 			item.hsn && this.$root.CurrentBusiness.GSTRegistrationStatus == 1 ? this.isHsn = true : '';
		// 			item.mrp && this.$root.TransactionSettings.mrpWiseStock ? this.isMrp = true : '';
		// 		}

		// 		this.headers.push({"name":"Taxable Value"});

		// 		for(let l=0; l<this.items.length; l++){
		// 			for(let k=0; k<this.items[l].gstAddOns.length; k++){
		// 				let headerIndex = this.headers.findIndex(header=>{
		// 					return header.gstAddOnsId == this.items[l].gstAddOns[k].addOnsId;
		// 				})

		// 				if(headerIndex==-1){
		// 					let obj = {};
		// 					obj.gstAddOnsId = this.items[l].gstAddOns[k].addOnsId;
		// 					obj.name = this.items[l].gstAddOns[k].name;
		// 					this.headers.push(obj);
		// 				}
		// 			}
		// 		}

		// 		//removing hsn column from invoice if not mentioned in any invoice
		// 		if(!this.isHsn){
		// 			this.headers.splice(2, 1);
		// 			for(let i=0; i<this.items.length; i++){
		// 				delete this.items[i].hsn;
		// 			}
		// 		}

		// 		//removing mrp column from invoice if not mentioned in any invoice
		// 		if(!this.isMrp){
		// 			this.headers.splice(3, 1);
		// 			for(let i=0; i<this.items.length; i++){
		// 				delete this.items[i].mrp;
		// 			}
		// 		}

		// 		// this.headers.push({"name":"Taxable Value"});
		// 		this.headers.push({"name":"Total"});

		// 		console.log(JSON.stringify(this.headers));
		// 		console.log(JSON.stringify(this.items));
		// 	},
		// 	fn_processSummary: function(){
		// 		let totalTax = 0;
		// 		let netTotal = 0;

		// 		this.addOnsTotal = [];
		// 		this.gstAddOnsTotal = [];
				
		// 		for(let i=0; i<this.items.length; i++){

		// 			netTotal += this.items[i].total;

		// 			for(let j=0; j<this.items[i].addOns.length; j++){

		// 				let addOnsIndex = this.addOnsTotal.findIndex(addOn=>{
		// 					return addOn.addOnsId == this.items[i].addOns[j].addOnsId;
		// 				});

		// 				if(addOnsIndex==-1){
		// 					let obj = {};
		// 					obj.addOnsId = this.items[i].addOns[j].addOnsId;
		// 					obj.name = this.items[i].addOns[j].name;
		// 					obj.value = this.items[i].addOns[j].value;
		// 					this.addOnsTotal.push(obj);
		// 				}
		// 				else{
		// 					this.addOnsTotal[addOnsIndex].value += this.items[i].addOns[j].value;
		// 				}
		// 			}

		// 			for(let k=0; k<this.items[i].gstAddOns.length; k++){

		// 				let addOnsIndex = this.gstAddOnsTotal.findIndex(addOn=>{
		// 					return addOn.gstAddOnsId == this.items[i].gstAddOns[k].addOnsId;
		// 				});

		// 				if(addOnsIndex==-1){
		// 					let obj = {};
		// 					obj.gstAddOnsId = this.items[i].gstAddOns[k].addOnsId;
		// 					obj.name = this.items[i].gstAddOns[k].name;
		// 					obj.value = this.items[i].gstAddOns[k].value;
		// 					this.gstAddOnsTotal.push(obj);
		// 				}
		// 				else{
		// 					this.gstAddOnsTotal[addOnsIndex].value += this.items[i].gstAddOns[k].value;
		// 				}

		// 				totalTax += this.items[i].gstAddOns[k].value;
		// 			}
		// 		}

		// 		this.summary.totalTax = this.roundUpto2Decimals(totalTax);
		// 		this.netTotal = this.roundUpto2Decimals(netTotal);

		// 		console.log(JSON.stringify(this.addOnsTotal));
		// 	},
		// 	fn_processSections: function(){
		// 		for(let i=0; i<this.data.templateSettings.printTemplateSections.length; i++){
		// 			let additionalData = this.data.templateSettings.printTemplateSections[i].addData;
		// 			if(this.data.templateSettings.printTemplateSections[i].sectionName == 'header'){
		// 				this.header = JSON.parse(additionalData);
		// 			}
		// 			else if(this.data.templateSettings.printTemplateSections[i].sectionName == 'terms'){
		// 				this.terms = JSON.parse(additionalData);
		// 			}
		// 			else if(this.data.templateSettings.printTemplateSections[i].sectionName == 'bankDetails'){
		// 				this.bankDetails = JSON.parse(additionalData);
		// 			}
		// 			else if(this.data.templateSettings.printTemplateSections[i].sectionName == 'signature'){
		// 				this.signatory = JSON.parse(additionalData);
		// 			}
		// 			else if(this.data.templateSettings.printTemplateSections[i].sectionName == 'subtitle'){
		// 				this.subtitle = JSON.parse(additionalData);
		// 			}
		// 			else if(this.data.templateSettings.printTemplateSections[i].sectionName == 'billingLabel'){
		// 				this.billingLabel = JSON.parse(additionalData);
		// 			}
		// 			else if(this.data.templateSettings.printTemplateSections[i].sectionName == 'shippingLabel'){
		// 				this.shippingLabel = JSON.parse(additionalData);
		// 			}
		// 		}
		// 	},
		// 	fn_processKeywords: function(){
		// 		this.fn_replaceKeywords(this.header);
		// 		this.fn_replaceKeywords(this.terms);
		// 		this.fn_replaceKeywords(this.bankDetails);
		// 		this.fn_replaceKeywords(this.signatory);
		// 		this.fn_replaceKeywords(this.subtitle);
		// 	},
		// 	fn_replaceKeywords: function(category){
		// 		if(category && category.content){
		// 			category.content = category.content.replace('{{BusinessName}}', this.$root.CurrentBusiness.BusinessName);
		// 			category.content = category.content.replace('{{BusinessAddress}}', this.$root.CurrentBusiness.Address ? this.$root.CurrentBusiness.Address : '');
		// 			category.content = category.content.replace('{{BusinessState}}', this.$root.CurrentBusiness.State);
		// 		}
		// 	},
		// 	fn_processPrintDetails: function(){
		// 		this.printDetails = JSON.parse(this.data.transactionDetails.partyDetails.printDetails);
		// 	},
		// 	convertNumberToWords: function(amount) {
		// 	    var words = new Array();
		// 	    words[0] = '';
		// 	    words[1] = 'One';
		// 	    words[2] = 'Two';
		// 	    words[3] = 'Three';
		// 	    words[4] = 'Four';
		// 	    words[5] = 'Five';
		// 	    words[6] = 'Six';
		// 	    words[7] = 'Seven';
		// 	    words[8] = 'Eight';
		// 	    words[9] = 'Nine';
		// 	    words[10] = 'Ten';
		// 	    words[11] = 'Eleven';
		// 	    words[12] = 'Twelve';
		// 	    words[13] = 'Thirteen';
		// 	    words[14] = 'Fourteen';
		// 	    words[15] = 'Fifteen';
		// 	    words[16] = 'Sixteen';
		// 	    words[17] = 'Seventeen';
		// 	    words[18] = 'Eighteen';
		// 	    words[19] = 'Nineteen';
		// 	    words[20] = 'Twenty';
		// 	    words[30] = 'Thirty';
		// 	    words[40] = 'Forty';
		// 	    words[50] = 'Fifty';
		// 	    words[60] = 'Sixty';
		// 	    words[70] = 'Seventy';
		// 	    words[80] = 'Eighty';
		// 	    words[90] = 'Ninety';
		// 	    amount = amount.toString();
		// 	    var atemp = amount.split(".");
		// 	    var number = atemp[0].split(",").join("");
		// 	    var n_length = number.length;
		// 	    var words_string = "";
		// 	    if (n_length <= 9) {
		// 	        var n_array = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0);
		// 	        var received_n_array = new Array();
		// 	        for (var i = 0; i < n_length; i++) {
		// 	            received_n_array[i] = number.substr(i, 1);
		// 	        }
		// 	        for (var i = 9 - n_length, j = 0; i < 9; i++, j++) {
		// 	            n_array[i] = received_n_array[j];
		// 	        }
		// 	        for (var i = 0, j = 1; i < 9; i++, j++) {
		// 	            if (i == 0 || i == 2 || i == 4 || i == 7) {
		// 	                if (n_array[i] == 1) {
		// 	                    n_array[j] = 10 + parseInt(n_array[j]);
		// 	                    n_array[i] = 0;
		// 	                }
		// 	            }
		// 	        }
		// 	        var value = "";
		// 	        for (var i = 0; i < 9; i++) {
		// 	            if (i == 0 || i == 2 || i == 4 || i == 7) {
		// 	                value = n_array[i] * 10;
		// 	            } else {
		// 	                value = n_array[i];
		// 	            }
		// 	            if (value != 0) {
		// 	                words_string += words[value] + " ";
		// 	            }
		// 	            if ((i == 1 && value != 0) || (i == 0 && value != 0 && n_array[i + 1] == 0)) {
		// 	                words_string += "Crores ";
		// 	            }
		// 	            if ((i == 3 && value != 0) || (i == 2 && value != 0 && n_array[i + 1] == 0)) {
		// 	                words_string += "Lakhs ";
		// 	            }
		// 	            if ((i == 5 && value != 0) || (i == 4 && value != 0 && n_array[i + 1] == 0)) {
		// 	                words_string += "Thousand ";
		// 	            }
		// 	            if (i == 6 && value != 0 && (n_array[i + 1] != 0 && n_array[i + 2] != 0)) {
		// 	                words_string += "Hundred and ";
		// 	            } else if (i == 6 && value != 0) {
		// 	                words_string += "Hundred ";
		// 	            }
		// 	        }
		// 	        words_string = words_string.split("  ").join(" ");
		// 	    }
		// 	    return words_string;
		// 	}
		// },
		// mounted(){
		// 	this.fn_init();
		// },
		// computed:{
		// 	filteredItems: function(){
		// 		let transactionGroups = [];

		// 		for(let i in this.items){

		// 			if(this.items[i].baseTransactionNumber != this.data.transactionDetails.transactionNumber){
		// 				this.isRef = true;
		// 			}

		// 	        let itemIndex = transactionGroups.findIndex(transItem => transItem.baseTransactionNumber==this.items[i].baseTransactionNumber);

		// 	        if(itemIndex!=-1){
		// 	            transactionGroups[itemIndex].items.push(this.items[i]);
		// 	        }
		// 	        else{
		// 	            let obj = {};
		// 	            obj.baseTransactionNumber = this.items[i].baseTransactionNumber;
		// 	            obj.items = []
		// 	            obj.items.push(this.items[i]);
		// 	            transactionGroups.push(obj);
		// 	        }
		// 	    }

		// 	    console.log(JSON.stringify(transactionGroups));

		// 	    return transactionGroups;
		// 	}
		// }
	}
</script>

<style>
	/* ---------------- Primary Header Css -----------------*/
	/*.template_4 .business_logo{
		width: 80px;
		height:80px;
		float: left;
	}

	.template_4 .business_logo img{
		width: 80px;
	}

	.template_4 .business_details{
		padding-left: 80px;
	}

	.template_4 tr.transaction_items:nth-child(even){
		background-color: #f9f9f9;
		-webkit-print-color-adjust: exact;
	}*/
	.template_4 .business_logo{
		margin-right: 4px;
		float: left;	
	}

	/* .template_4.preview .business_details{
		padding-left: 56px;
		position:relative;
	} */

	.template_4 .business_details{
		display: grid;
	}

	.template_4.print-settings .business_details{
		/* margin-left: 56px; */
		padding:0 !important;
	}

	.template_4 .hasLogo .business_details{
		/* margin-left: 56px; */
		padding:0 !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/invoice_templates/invoices/template4.vue